import dayjs from 'dayjs';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
import { determineLanguage, langs } from '@constants/i18n';
import { LS_KEY } from '@constants/storage';

export const initializeI18n = async () => {
  const languageDetector = new LanguageDetector(null, {
    caches: ['localStorage'],
    lookupLocalStorage: LS_KEY.lang,
    order: ['localStorage', 'cookie', 'navigator'],
  });

  // browserの言語は"ja"のようにshortCodeで返される場合があるため、"ja-JP"のように完全な形式に変換する
  const initLng = determineLanguage(
    languageDetector.detect(['localStorage', 'cookie', 'navigator']),
  );

  await i18n
    .use(HttpBackend)
    .use(languageDetector)
    .use(initReactI18next)
    .init({
      backend: {
        loadPath: '/locales/{{lng}}/{{ns}}.json',
      },
      debug: process.env.NEXT_PUBLIC_I18NEXT_DEBUG === 'true',
      fallbackLng: {
        // 言語ファイルのリソースが存在しないその他の言語は日本語にフォールバック。
        default: [langs.ja],
        // 設定言語が以下の場合、フォールバックのリソースは読み込まない。
        'en-US': [langs.en],
        'ja-JP': [langs.ja],
        'zh-CN': [langs.cn],
        'zh-TW': [langs.tw],
        'ko-KR': [langs.ko],
      },
      interpolation: {
        escapeValue: false, // react already safes from xss
      },
      lng: initLng,
      load: 'currentOnly',
      partialBundledLanguages: true,
      react: {
        transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'b', 'span'],
        transSupportBasicHtmlNodes: true,
      },
      supportedLngs: Object.values(langs),
    });

  switch (i18n.language) {
    case langs.en:
      dayjs.locale('en');
      break;
    case langs.cn:
      dayjs.locale('zh-cn');
      break;
    case langs.tw:
      dayjs.locale('zh-tw');
      break;
    case langs.ko:
      dayjs.locale('ko');
      break;
    default:
      dayjs.locale('ja');
      break;
  }
};
